<template>
  <ClientsHeader :currentTab="tab && tab.key">
    <ClientProspectionStats v-if="tab && tab.key === 'prospection'" ref="stats" :callback="openClient" />
    <ClientTable ref="table" :key="$route.fullPath" :defaultFilters="tab && tab.filters" :hasArchiveView="tab && tab.hasArchiveView" :loadedCallback="refreshStats"/>
  </ClientsHeader>
</template>

<script>
    import ClientTable from "@/components/tables/ClientTable.vue";
    import ClientsHeader from "@/components/ClientsHeader.vue";
    import ClientProspectionStats from "@/components/ClientProspectionStats.vue";
    import {CLIENT_TABS} from "@/components/clientTabs";

    // Anciens liens (#prospection, #converted) : ils pointent désormais vers la rubrique correspondante
    const LEGACY_HASHES = {'#prospection': 'prospection', '#converted': 'acquis'};

    export default {
        name: 'ClientListView',
        components: {
          ClientsHeader,
          ClientProspectionStats,
          ClientTable
        },
        computed: {
          // Rubrique affichée : celle de l'adresse, sinon la première. Une fiche demandée par son nom (#edit-client)
          // s'ouvre sans rubrique, pour la retrouver quel que soit son statut.
          tab() {
            const key = this.$route.params.tab || LEGACY_HASHES[this.$route.hash];
            if (key) return CLIENT_TABS.find(tab => tab.key === key);
            return this.$route.hash === '#edit-client' ? undefined : CLIENT_TABS[0];
          }
        },
        methods: {
          openClient(client) {
            this.$refs.table?.openClient(client);
          },
          // Appelé après chaque chargement du tableau : le suivi de la prospection reste à jour des modifications
          refreshStats() {
            this.$refs.stats?.load();
          }
        }
    }
</script>

<style lang="stylus">
  main
    align-content start
</style>
